import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import successGif from '../../../assets/images/successTick100.gif';
import errorGif from '../../../assets/images/errorTick100.gif';
import './GenericDialog.scss';

const GenericDialog = ({
    open,
    onClose,
    title,
    message,
    buttonText = 'Close',
    severity = 'success'
}) => {
    const getStatusIcon = () => {
        return severity === 'success' ? successGif : errorGif;
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={`generic-dialog dialog-${severity}`}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <div className="dialog-content-wrapper">
                    <img
                        src={getStatusIcon()}
                        alt={severity}
                        className="status-icon"
                    />
                    <p className="dialog-message">{message}</p>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{buttonText}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default GenericDialog;
